/**
 * Date and time formatting utilities for Loops
 * Ensures strict timezone consistency (Europe/Zurich) across local and cloud environments.
 */

export const TIMEZONE = 'Europe/Zurich';

export function parseToDate(val) {
  if (!val) return null;
  if (val instanceof Date) return isNaN(val.getTime()) ? null : val;
  const str = String(val).trim();
  if (/^\d{1,2}:\d{2}(:\d{2})?$/.test(str)) return null;
  let d = new Date(str);
  if (!isNaN(d.getTime())) return d;
  if (/^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}/.test(str)) {
    d = new Date(str.replace(' ', 'T'));
    if (!isNaN(d.getTime())) return d;
  }
  return null;
}

export function formatLocalTimeHHMM(val) {
  if (!val) return '--:--';
  const str = String(val).trim();
  if (/^\d{1,2}:\d{2}(:\d{2})?$/.test(str)) {
    return str.slice(0, 5);
  }
  const d = parseToDate(val);
  if (d) {
    try {
      return new Intl.DateTimeFormat('fr-CH', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: TIMEZONE
      }).format(d);
    } catch (e) {
      const h = String(d.getHours()).padStart(2, '0');
      const m = String(d.getMinutes()).padStart(2, '0');
      return `${h}:${m}`;
    }
  }
  return str.length >= 5 ? str.slice(0, 5) : str;
}

export function calcDepartureTimeStr(arrivalTimeFormatted, serviceMins) {
  const [hStr, mStr] = (arrivalTimeFormatted || '08:00').split(':');
  const totalMins = (parseInt(hStr || 8, 10) * 60) + parseInt(mStr || 0, 10) + parseInt(serviceMins || 10, 10);
  const depH = Math.floor(totalMins / 60) % 24;
  const depM = totalMins % 60;
  return `${String(depH).padStart(2, '0')}:${String(depM).padStart(2, '0')}`;
}

export function formatDurationSec(totalSec = 0) {
  const h = Math.floor((totalSec || 0) / 3600);
  const m = Math.floor(((totalSec || 0) % 3600) / 60);
  if (h === 0) return `${m} min`;
  return `${h}h ${m}m`;
}
